/**
 * PeerCountryHubs — inter-hub navigation.
 *
 * Rendered ONLY at the bottom of a country-hub article
 * (contentType === "country-hub"). Shows the other four country hubs
 * so readers can jump from Vietnam → Indonesia → Thailand etc. without
 * going back to the Blog list.
 */
import { Link } from "react-router-dom";
import { ArrowUpRight } from "lucide-react";
import { COUNTRY_HUBS } from "@/lib/countryHubs";
import { trackCtaClick } from "@/lib/ga";

export default function PeerCountryHubs({ currentCode }) {
  const peers = COUNTRY_HUBS.filter((h) => h.code !== currentCode);
  if (peers.length === 0) return null;
  return (
    <section
      className="my-14 border-t border-neutral-200 pt-10"
      data-testid="peer-country-hubs"
    >
      <p className="text-[11px] uppercase tracking-[0.2em] text-[#86868b]">
        Continue exploring
      </p>
      <h3 className="mt-3 text-[20px] md:text-[22px] tracking-[-0.01em] text-neutral-900 font-medium text-balance">
        Compare sourcing in other pan-Asian markets
      </h3>

      <ul className="mt-6 grid grid-cols-1 sm:grid-cols-2 gap-3">
        {peers.map((c) => (
          <li key={c.code} className="list-none">
            <Link
              to={`/blog/${c.hubSlug}`}
              data-testid={`peer-country-hub-${c.code}`}
              onClick={() =>
                trackCtaClick(`Peer Country Hub: ${c.label}`, `blog-peer-hub:${c.code}`, {
                  country: c.code,
                  from: currentCode,
                })
              }
              className="group flex items-center justify-between gap-4 rounded-lg border border-neutral-200 px-4 py-3 bg-white hover:border-neutral-900 transition-colors"
            >
              <div>
                <div className="text-[15px] font-medium tracking-[-0.005em] text-neutral-900">
                  Sourcing from {c.label}
                </div>
                <p className="mt-0.5 text-[12.5px] leading-snug text-neutral-500">
                  {c.lead}
                </p>
              </div>
              <ArrowUpRight
                size={14}
                className="shrink-0 text-neutral-500 group-hover:text-neutral-900 transition-colors"
                aria-hidden
              />
            </Link>
          </li>
        ))}
      </ul>
    </section>
  );
}
